import { useToggle } from "client/hooks/utils/useToggle";
import { translateFunc } from "client/utils/translateFunc";
import { Popup } from "components/common/Popup/Popup";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useFindTextBox } from "../useFindTextBox";
import { AlignmentOptions } from "./AlignmentOptions/AlignmentOptions";

export interface AlignmentProps {
    textBoxId: string;
}

export const Alignment = ({ textBoxId }: AlignmentProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const { isOpen, onClose: close, toggle } = useToggle();
    return (
        <Popup isOpen={isOpen} close={close} content={<AlignmentOptions textBox={textBox} />}>
            <ToolTip text={translateFunc("text-alignment")}>
                <button
                    className={`w-10 h-10 flex items-center justify-center ${
                        isOpen ? "bg-irGray-200 dark:bg-darkSurface-300" : "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
                    } rounded-lg`}
                    onClick={toggle}
                >
                    <AlignmentIcon />
                </button>
            </ToolTip>
        </Popup>
    );
};

const AlignmentIcon = () => (
    <svg width={22} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-black dark:fill-white">
        <path d="M21.34 0H.66C.298 0 0 .267 0 .593c0 .326.297.592.66.592h20.68c.363 0 .66-.266.66-.592C22 .267 21.704 0 21.34 0ZM15.196 4.918H.66c-.364 0-.661.267-.661.593 0 .326.297.593.66.593h14.536c.363 0 .66-.267.66-.593 0-.326-.297-.593-.66-.593ZM21.34 9.896H.66c-.363 0-.66.267-.66.593 0 .326.297.592.66.592h20.68c.363 0 .66-.266.66-.592 0-.326-.297-.593-.66-.593ZM9.976 14.815H.661c-.364 0-.661.266-.661.592 0 .326.297.593.66.593h9.316c.364 0 .66-.267.66-.593 0-.326-.296-.592-.66-.592Z" />
    </svg>
);
